var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('organizationDetails',{attrs:{"me":_vm.me,"organizationId":_vm.$route.params.organizationId}})}
var staticRenderFns = []

export { render, staticRenderFns }